import { ViewModel,View, ObservableArray } from "binder"
import { WindowContainerViewModel } from "../windowContainer/windowContainer-viewModel";
import  { MessageBoxView } from "./messageBox-view"

export class MessageBoxViewModel extends ViewModel{
    constructor(parentViewModel: WindowContainerViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.buttons = ObservableArray.create<singleButton>();
    }

    GetDefaultView(): View <ViewModel> {
        return new MessageBoxView();
    }
    public getTypeId(): string {
        return "VM-5AF9673F-FB39-4EEC-AD74-C2E31863874F"
    }

    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set messsage(v: string) { this._messsage = v; } public get messsage(): string { return this._messsage;} private _messsage: string;
    public set type(v: string) { 
        this._type = v; 
        this.isDanger = v=="danger";
        this.isSuccess = v=="success";
        this.isWarning = v=="warning";
        this.isDark = v=="dark";
    } public get type(): string { return this._type;} private _type: string;

    public set buttons(v: ObservableArray<singleButton>) { this._buttons = v; } public get buttons(): ObservableArray<singleButton> { return this._buttons;} private _buttons: ObservableArray<singleButton>;
    public set isDanger(v: boolean) { this._isDanger = v; } public get isDanger(): boolean { return this._isDanger;} private _isDanger: boolean;
    public set isSuccess(v: boolean) { this._isSuccess = v; } public get isSuccess(): boolean { return this._isSuccess;} private _isSuccess: boolean;
    public set isWarning(v: boolean) { this._isWarning = v; } public get isWarning(): boolean { return this._isWarning;} private _isWarning: boolean;
    public set isDark(v: boolean) { this._isDark = v; } public get isDark(): boolean { return this._isDark;} private _isDark: boolean;
    
    private _typedParent: WindowContainerViewModel;

    public resolveFunction : (str:string)=>void;

    resolve(resultCode: string) {
        this._typedParent.closeMessageBox();
        setTimeout(()=>this.resolveFunction(resultCode),100);
    }
}
export class singleButton extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:MessageBoxViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set className(v: string) { 
        this._className = v; 
        this.isDanger = v=="danger";
        this.isInfo = v=="info";
        this.isSuccess = v=="success";
        this.isPrimary = v=="primary";
        this.isWarning = v=="warning";
        this.isSecondary = v=="secondary";
    } public get className(): string { return this._className;} private _className: string;
    
    public set resultCode(v: string) { this._resultCode = v; } public get resultCode(): string { return this._resultCode;} private _resultCode: string;
    public set isDanger(v: boolean) { this._isDanger = v; } public get isDanger(): boolean { return this._isDanger;} private _isDanger: boolean;
    public set isInfo(v: boolean) { this._isInfo = v; } public get isInfo(): boolean { return this._isInfo;} private _isInfo: boolean;
    public set isSuccess(v: boolean) { this._isSuccess = v; } public get isSuccess(): boolean { return this._isSuccess;} private _isSuccess: boolean;
    public set isPrimary(v: boolean) { this._isPrimary = v; } public get isPrimary(): boolean { return this._isPrimary;} private _isPrimary: boolean;
    public set isSecondary(v: boolean) { this._isSecondary = v; } public get isSecondary(): boolean { return this._isSecondary;} private _isSecondary: boolean;
    public set isWarning(v: boolean) { this._isWarning = v; } public get isWarning(): boolean { return this._isWarning;} private _isWarning: boolean;
    
    private _typedParent:MessageBoxViewModel;

    click(){
        this._typedParent.resolve(this.resultCode);
    }
}